import request from '@/utils/request'

let SubApplymentApi = {

  /*子商户申请列表*/
  applymentList(data, errorback) {
    return request._postBody('/supplier/setting/applyment/index', data, errorback);
  },
  /*添加子商户申请*/
  addWxApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/wx/add', data, errorback);
  },
  addAlipayApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/alipay/add', data, errorback);
  },
  addLakalaApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/lakala/add', data, errorback);
  },
  /*子商户申请详情*/
  applymentDetail(data, errorback) {
    return request._get('/supplier/setting/applyment/toEdit', data, errorback);
  },
  editWxApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/wx/edit', data, errorback);
  },
  editAlipayApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/alipay/edit', data, errorback);
  },
  /*修改子商户申请*/
  editLakalaApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/lakala/edit', data, errorback);
  },
  /*删除子商户申请*/
  deleteApplyment(data, errorback) {
    return request._post('/supplier/setting/applyment/delete', data, errorback);
  },
  applyApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/apply', data, errorback);
  },
  rollbackApplyment(data, errorback) {
    return request._postBody('/supplier/setting/applyment/rollback', data, errorback);
  },
}

export default SubApplymentApi;



// WEBPACK FOOTER //
// ./src/api/subApplyment.js